import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import api from "../../../../api/api";
import ImageUploader from "./upload_image";
import classNames from "classnames";
import {toast} from "react-toastify";
import {FormControl, MenuItem, Select} from "@mui/material";

const ImagePage = () => {
    const [dataImage, setDataImage] = useState({})
    const [textData, setTextData] = useState([])
    const [timeZoneId, setTimeZoneId] = useState(null)
    const [timezones, setTimezones] = useState([{id: 1, name: "Hello"}])

    const handleSave = async () => {
        try {
            const res = await api().post('reports/fields/save', textData?.map((el) => ({
                report_field_id: el?.report_field_id,
                report_field_value: el?.report_field_value
            })))
            // debugger
            toast.success('Данные обновлены!')
        } catch (e) {
            console.log(e)
            toast.error('Ошибка')
        }
    }

    useEffect(() => {
        const getImages = async () => {
            try {
                const res = await api().get('reports/images')
                const res2 = await api().get('reports/fields')
                setTextData(res2?.data?.report_fields)
                setDataImage({
                    'f': res?.data?.report_images?.find((f) => f?.report_image_id == 1),
                    's': res?.data?.report_images?.find((f) => f?.report_image_id == 2),
                    't': res?.data?.report_images?.find((f) => f?.report_image_id == 3),
                    'l': res?.data?.report_images?.find((f) => f?.report_image_id == 4),
                })
            } catch (e) {
                console.log(e)
            }
        }

        const getTimezones = async () => {
            const res = await api().get('/timezones/list')
            setTimezones(res?.data?.timezones)
            setTimeZoneId(res?.data?.current_id);
        }

        getImages()
        getTimezones().then()
    }, [])

    async function setTimezoneMethod(id) {
        setTimeZoneId(id)
        try {
            await api().post('/timezones/timezone', { id });
            toast.success('Часовой пояс сохранён')
        } catch (e) {
            console.log(e)
            toast.error('Ошибка')
        }
    }

    return (
        <div className={s.content}>
            <div className={s.content_top}>
                <div className={s.item}>
                    <ImageUploader img={dataImage?.f}/>
                </div>
                <div className={classNames(s.item, s.item_input)}>
                    <p className={s.title}>Текст</p>
                    {textData?.map((el, i) => {
                        return <div key={i} className={s.input_box}>
                            <p className={s.input_title}>{el?.report_field_name}</p>
                            <input type={"text"}
                                   value={el.report_field_value}
                                   onChange={(e) => {
                                       setTextData(textData?.map((td) => td?.report_field_id === el?.report_field_id ? ({
                                           ...td,
                                           report_field_value: e.target?.value
                                       }) : td))
                                   }}/>
                        </div>
                    })}
                    <div className={s.btn_save_box}>
                        <div style={{width: '100%'}}>
                            <FormControl sx={{ minWidth: '350px' }}>
                                <Select
                                    key={timeZoneId}
                                    value={timeZoneId ?? ''}
                                    onChange={(e) => setTimezoneMethod(e.target.value)}
                                    displayEmpty
                                    renderValue={(selected) => {
                                        if (selected === null || selected === '') return 'Выберите часовой пояс';
                                        const tz = timezones.find(t => t.id === Number(selected));
                                        return tz ? tz.name : 'Неизвестно';
                                    }}
                                    sx={{ height: '45px', backgroundColor: '#fff' }}
                                >
                                    {timezones.map((el) => (
                                        <MenuItem key={el.id} value={el.id}>
                                            {el.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div className={s.btn_save} onClick={handleSave}>Сохранить</div>
                    </div>

                </div>
                <div className={s.item}>
                    <ImageUploader img={dataImage?.s}/>
                </div>
            </div>

            <div className={s.line}/>
            <div className={s.content_bottom}>
                <div className={classNames(s.item, s.item_l)}>
                    <ImageUploader img={dataImage?.l} width={'100%'}/>
                </div>

                <div className={classNames(s.item, s.item_l)}>
                    <ImageUploader img={dataImage?.t}/>
                </div>
            </div>
        </div>
    );
};

export default ImagePage;
